{
    "locale": "ja-JP",
    "General": {
        "OrText": "または",
        "Title_MyHubert": "My Hubert",
        "Button_GoTo_MyHubert": "My Hubert へ移動"
    },
    "Header": {
        "ButtonText_CreateNewAccount": "アカウントを作成",
        "ButtonText_SignInToYourAccount": "アカウントにログイン",
        "ButtonText_StartInterviewWithoutSigningUp": "登録せずにインタビューを開始",
        "ButtonText_StartInterviewWithoutSigningIn": "ログインせずにインタビューを開始",
        "Navlink_Dashboard": "ダッシュボード",
        "Navlink_MyInterviews": "マイインタビュー",
        "Navlink_LearnWithHubert": "Hubertで学ぶ",
        "Navlink_HelpCenter": "ヘルプセンター",
        "MyProfile": "マイプロフィール",
        "LogOut": "ログアウト"
    },
    "Login": {
        "MainTitle": "Hubertインタビューの結果を確認する",
        "Subtitle": "ログインして結果を確認し、フィードバックやアドバイスを受け取りましょう。",
        "LoginTitle": "Hubertアカウントにログイン",
        "Label_Email": "メールアドレス",
        "Label_Password": "パスワード",
        "ButtonText_SignIn": "ログイン",
        "ButtonText_ForgotPassword": "パスワードをお忘れですか？",
        "ButtonText_ContinueWithGoogle": "Googleで続ける",
        "OrSeparator": "または",
        "Error_Email_Required": "メールアドレスは必須です。",
        "Error_Email_Invalid": "有効なメールアドレスを入力してください。",
        "Error_Password_Required": "パスワードは必須です。",
        "Error_Use_Same_Email_As_Interview": "インタビューで使用したメールアドレスを入力してください。"
    },
    "Registration": {
        "MainTitle": "Hubertインタビューの結果を確認する",
        "Subtitle": "登録して結果を確認し、フィードバックやアドバイスを受け取りましょう。",
        "RegistrationTitle": "Hubertアカウントを作成",
        "BenefitsBox_Title": "できること",
        "BenefitsBox_Point1": "インタビュー履歴へのアクセス",
        "BenefitsBox_Point2": "インタビューのフィードバックを受け取る",
        "BenefitsBox_Point3": "新しいインタビューで回答を再利用",
        "BenefitsBox_Point4": "インタビューのアドバイスを取得",
        "BenefitsBox_Point5": "キャリアガイドを読む",
        "BenefitsBox_Point6": "その他多数",
        "Label_FirstName": "名",
        "Label_LastName": "姓",
        "Label_Email": "メールアドレス",
        "Label_Password": "パスワード",
        "Label_PhoneNumber": "電話番号",
        "Label_TermsOfService": "以下に同意します",
        "Label_TermsOfServiceLink": "プライバシーポリシーおよび利用規約",
        "Placeholder_CountryCode": "国番号を選択",
        "Placeholder_PhoneNumber": "例：09012345678",
        "HelpText_Password": "パスワードは6文字以上である必要があります。",
        "ButtonText_SignUp": "登録",
        "ButtonText_SignUpWithGoogle": "Googleで登録",
        "OrSeparator": "または",
        "Error_FirstName_Required": "名は必須です。",
        "Error_LastName_Required": "姓は必須です。",
        "Error_Email_Required": "メールアドレスは必須です。",
        "Error_Email_Invalid": "有効なメールアドレスを入力してください。",
        "Error_Email_Exists": "このメールアドレスは既に使用されています。",
        "Error_Password_Required": "パスワードは必須です。",
        "Error_Password_6_Characters": "パスワードは6文字以上である必要があります。",
        "Error_PhoneNumber_Required": "電話番号は必須です。",
        "Error_PhoneNumber_Invalid": "電話番号が無効です。",
        "Error_PrivacyPolicyCheck_Required": "プライバシーポリシーと利用規約への同意が必要です。"
    },
    "RegistrationInviteEmail": {
        "Subtitle_BeforeInterviewCompleted": "インタビューを受けるには、Hubertの利用規約に同意する必要があります。チェックボックスをオンにして進んでください。",
        "Subtitle_AfterInterviewCompleted": "登録して結果を確認し、フィードバックやアドバイスを受け取りましょう。",
        "PrivacyPolicyText": "登録することで、以下に同意したことになります",
        "PrivacyPolicyLink": "プライバシーポリシーおよび利用規約",
        "ButtonText_SignUp": "登録してインタビューへ",
        "ButtonText_SignUpNormal": "登録",
        "ButtonText_SignInInstead": "ここをクリックしてログイン"
    },
    "LoginInviteEmail": {
        "Subtitle": "ログインして結果を確認し、フィードバックやアドバイスを受け取りましょう。"
    },
    "AppMessages": {
        "internal-server-error": "予期しないエラーが発生しました。",
        "invalid-credentials": "無効な認証情報です。もう一度お試しください。",
        "user-not-found": "無効な認証情報です。もう一度お試しください。",
        "account-not-found": "無効なアカウントです。もう一度お試しください。",
        "verify-email-title": "メールアドレスを確認してください",
        "verify-email-subtitle": "メールを確認してアカウントを認証してください。",
        "email-not-verified-title": "メールアドレスが認証されていません",
        "email-not-verified-subtitle": "メールを確認してアカウントを認証してください。",
        "verifying-email-title": "メールを認証中",
        "verifying-email-subtitle": "お待ちください...",
        "sign-in-title": "ログイン中",
        "sign-in-subtitle": "お待ちください...",
        "server-error": "問題が発生しました。",
        "hubert-user-exists": "アカウントは既に存在します。",
        "account-exists": "アカウントは既に存在します。",
        "email-verified": "メールアドレスが認証されました。",
        "email-is-taken": "メールアドレスは既に使用されています。",
        "re-enter-password": "パスワードを使用してログインしてください",
        "password-reset": "パスワードが変更されました。",
        "re-enter-new-password": "新しいパスワードを使用してログインしてください",
        "invalid-invitation": "無効な招待です。",
        "invalid-code": "無効な認証コードです。",
        "email-already-verified": "メールアドレスは既に認証されています。",
        "email-mismatch-title": "メールアドレスが一致しません",
        "email-mismatch-subtitle": "応募時に使用したメールアドレスを使用してください。"
    },
    "TransitionPage": {
        "loading-title": "読み込み中...",
        "loading-subtitle": "データを準備しています...",
        "logout-title": "読み込み中...",
        "logout-subtitle": "ログアウトしています..."
    },
    "ImpersonationPage": {
        "loading-title": "読み込み中...",
        "loading-subtitle": "データを準備しています..."
    },
    "ProcessInvitation": {
        "loading-title": "読み込み中...",
        "loading-subtitle": "インタビューを読み込んでいます。",
        "InvitationNotFound": "インタビューが見つかりません。",
        "InvitationExpired": "インタビューへのリンクは期限切れです。",
        "InvitationExpired_Description1": "以下からインタビューを開いてください.",
        "InvitationExpired_Description2": "または採用担当者に連絡してください.",
        "InvitationInvalid": "この招待リンクは無効です。",
        "InterviewCompleted": "このインタビューは既に完了しています。"
    },
    "Common": {
        "MyInterviews": {
            "Title": "マイインタビュー",
            "TableHead_Employer": "雇用主",
            "TableHead_Job": "職種",
            "TableHead_Status": "ステータス",
            "TableHead_ApplicationDate": "応募日",
            "TableBody_StartInterview": "インタビューは完了していません。ここをクリックして開始または再開してください。",
            "TableBody_NotScored": "インタビューは完了しました。結果はまもなく表示されます。",
            "TableBody_Details": "ここをクリックして結果と詳細を確認してください。",
            "ApplicationDate_Invited": "招待済み",
            "ApplicationDate_MinuteAgo": "1分前",
            "ApplicationDate_MinutesAgo": "分前",
            "ApplicationDate_HourAgo": "1時間前",
            "ApplicationDate_HoursAgo": "時間前",
            "ApplicationDate_DayAgo": "1日前",
            "ApplicationDate_DaysAgo": "日前",
            "ButtonText_SeeAllInterviews": "すべてのインタビューを表示",
            "ButtonText_Details": "詳細",
            "ButtonText_StartInterview": "インタビューへ",
            "ButtonText_NotScored": "結果待ち",
            "NoInterviews_Message": "過去または予定されているインタビューの記録はありません。"
        },
        "LatestJobPostings": {
            "NoJobPostings": "現在、求人情報はありません。後ほど再度ご確認ください。"
        }
    },
    "Dashboard": {
        "MyCareer": {
            "Title": "マイキャリア",
            "Subtitle": "インタビューを選択して評価と見通しを確認してください。",
            "MostRecentInterview": "最新のインタビュー",
            "ToDo": "ToDo",
            "NoOngoingInterviews_Title": "新しいインタビューの招待はありません。",
            "NoOngoingInterviews_Subtitle": "新しいHubertインタビューは、採用担当者がスケジュールするとここに表示されます。",
            "NoRecentInterviews_Title": "過去のインタビュー記録はありません。",
            "NoRecentInterviews_Subtitle": "採用担当者から招待されると、ここに表示されます。",
            "ButtonText_StartInterview": "インタビューへ",
            "ButtonText_NotScored": "結果待ち",
            "ButtonText_Details": "詳細"
        },
        "LearnWithHubert": {
            "Title": "Hubertで学ぶ",
            "Subtitle": "インタビューや仕事でのパフォーマンスを向上させるアドバイスを取得しましょう。",
            "PickedForMe": "最新記事",
            "ButtonText_SeeAllArticles": "すべての記事を表示"
        },
        "HubertTip": {
            "Title": "Hubertのヒント",
            "Subtitle": "インタビューをより速く",
            "Description": "以前Hubertインタビューを受けたことのある同様の職種に応募していますか？以前の回答を再利用して時間を節約できます.",
            "ButtonText_ReadMoreTips": "ヒントを読む"
        },
        "NewCandidateModalPopup": {
            "Title": "準備完了！",
            "DescriptionLine1": "アカウントの準備ができました.",
            "DescriptionLine2": "インタビューとプロフィールを管理しましょう。結果を確認し、フィードバックを得て、インタビューの方法について学びましょう.",
            "ButtonText_LetsGo": "始めましょう"
        },
        "InterviewCompletedModal": {
            "Title": "お疲れ様でした！",
            "Subtitle": "インタビューが完了しました。",
            "Description": "採用担当者がすべての応募を確認し、更新があり次第、メールまたは電話でフィードバックを提供します.",
            "ButtonText_Continue": "続ける"
        },
        "LatestJobPostings": {
            "Title": "最新の求人",
            "Subtitle": "最近投稿されたHubertパートナーからの他のオファーを探索しましょう。"
        }
    },
    "MyInterviews": {
        "MyInterviewsSection_Title": "マイインタビュー",
        "MyInterviewsSection_Subtitle": "インタビューを選択して評価とキャリアの機会を確認してください。",
        "MyInterviewsSection_ToDo": "ToDo"
    },
    "Interview": {
        "ButtonText_SeeAllInterviews": "すべてのインタビューを表示",
        "InterviewNotFound_Title": "アクセス不可",
        "InterviewNotFound_Description": "アカウントに関連付けられていないインタビューの詳細にアクセスしようとしています.",
        "ButtonText_GoToAllInterviews": "マイインタビューへ",
        "InterviewDetails": {
            "Title": "インタビュー詳細",
            "ForRole": "職種",
            "InterviewCompletedOn": "{{date}} {{time}} に完了"
        },
        "MyResult": {
            "Title": "マイ結果",
            "Subtitle": "評価されたマッチ度",
            "ButtonText_LearnMore": "回答がどう評価されるかを見る",
            "GotPotential_Title": "高いポテンシャル、要件の確認が必要",
            "GotPotential_Description": "あなたの回答はこのタイプの職種に対して高いポテンシャルを示しています。ただし、今回のインタビューに基づくと、特定の要件を1つ以上満たしていない可能性があります。これが次のステップに影響するかどうかは、採用担当者のニーズや他の候補者の状況によります。 次の段階に進めない場合でも、それはあなたのポテンシャルを否定するものではありません。多くの場合、その役割の特定のニーズに正確に適合するかどうかの問題です。以下の機会やヒントを確認してください.",
            "GotPotential_DescriptionSecondary": "Hubertの評価は助言的なものです。最終決定は採用担当者が行い、候補者数などの他の要因も結果に影響を与える可能性があります.",
            "GreatMatch_Title": "高いマッチ度",
            "GreatMatch_Description": "あなたの回答は、採用担当者がこの職種に通常求めているものとよく一致しており、要件を満たしています。素晴らしい結果です。採用担当者がすべての候補者を確認し、次のステップを決定します。",
            "GreatMatch_DescriptionSecondary": "Hubertの評価は助言的なものです。最終決定は採用担当者が行い、候補者数などの他の要因も結果に影響を与える可能性があります. 次の段階に進めない場合でも、それはあなたのポテンシャルを否定するものではありません。多くの場合、その役割の特定のニーズに正確に適合するかどうかの問題です。以下の機会やヒントを確認してください.",
            "OkMatch_Title": "要件を満たしています、さらにインパクトを",
            "OkMatch_Description": "あなたは職務要件を満たしています。さらに際立つためには、回答にもう少し明確さと具体性が必要かもしれません。以下の回答を見直して、具体的な例や結果を追加することでスコアを上げられる箇所を確認してください。",
            "OkMatch_DescriptionSecondary": "Hubertの評価は助言的なものです。最終決定は採用担当者が行い、候補者数などの他の要因も結果に影響を与える可能性があります.",
            "NotClearMatch_Title": "現時点ではマッチしない可能性があります",
            "NotClearMatch_Description": "このインタビューに基づくと、あなたの回答は採用担当者が求めているものと一致しない部分があるか、要件を満たしていない可能性があります。改善したい場合は、以下の質問から始めてください。小さな変更、具体性、明確な結果の提示が、次回大きな違いを生む可能性があります。",
            "NotClearMatch_DescriptionSecondary": "Hubertの評価は助言的なものです。最終決定は採用担当者が行い、候補者数などの他の要因も結果に影響を与える可能性があります."
        },
        "ScoreBox": {
            "ProfessionalExperiences": "職務経験、動機、およびコンピテンシー",
            "QualifyingRequirements": "この特定の職種の資格要件",
            "NotQualified_Title": "注力すべき点",
            "NotQualified_Description": "あなたの回答は、採用担当者が期待するよりも具体性や成果の提示が少なかったかもしれません。具体的な例、行動、明確な結果を追加することで回答を強化できる箇所を確認してください.",
            "GreatResults_Title": "強力な回答",
            "GreatResults_Description": "あなたの回答は、このタイプの職種に適しており、明確に伝わっています。改善できる質問がある場合は、以下に表示されます.",
            "MeetingRequirements_Title": "要件を満たしています",
            "MeetingRequirements_Description": "あなたの回答は、採用担当者が設定した資格要件を満たしていることを示しています。良い基盤です.",
            "NotAllExpectationsMet_Title": "1つ以上の要件が不足",
            "NotAllExpectationsMet_Description": "回答に基づくと、証明書、免許、学歴、経験年数など、この特定の職種の資格要件を1つ以上満たしていない可能性があります.",
            "ButtonText_FindOutPossibleReasons": "詳細を見る"
        },
        "ScriptFromInterview": {
            "Title": "インタビュー全文を読む",
            "ButtonText_SeeWholeTranscript": "インタビューを読む",
            "ButtonText_DeleteInterview": "インタビューを削除",
            "Loading_Title": "読み込み中...",
            "Loading_Subtitle": "インタビューの記録を読み込んでいます。"
        },
        "HowToImproveAtInterviews": {
            "Title": "インタビューの改善方法",
            "Subtitle_Questions": "回答を改善できる可能性のある質問はこちらです。",
            "Subtitle_NoQuestions": "特定の回答は指摘されませんでした。この職種でインパクトを与えるための最良の方法はこちらです。",
            "GreatMatch_Questions_Description": "高いマッチ度であっても、回答をさらに強化できる場合があります。該当するものがある場合は以下に表示されます。各質問の前の指示に従ってください。状況を説明する際は、状況、行動、結果を含めてください。極端に短い回答は避けましょう。対面インタビューのように、明確で具体的な説明を心がけてください.",
            "GreatMatch_NoQuestions_Description": "ほとんどの質問で良い回答ができました。素晴らしいです.",
            "OkMatch_Questions_Description": "回答を改善できる質問が以下に表示されます。各質問の前の指示に従ってください。状況を説明する際は、状況、行動、結果を含めてください。極端に短い回答は避けましょう。対面インタビューのように、明確で具体的な説明を心がけてください.",
            "OkMatch_NoQuestions_Description": "あなたの回答は堅実でしたが、競争が激しい職種かもしれません。そのため、良い回答でも平均的と見なされることがあります.",
            "OkMatch_NoQuestions_DescriptionSecondary": "次回は、明確さとインパクトを目指してください。結果から始め、実例を1つ追加し、通常3〜6文で簡潔にまとめてください。何をしたか、どのようにしたか、それによって何が変わったかを具体的に説明しましょう.",
            "GotPotential_Questions_Description": "この職種に高い適性があるように見えても、回答を強化できる場合があります。該当するものがある場合は以下に表示されます。各質問の前の指示に従ってください。状況を説明する際は、状況、行動、結果を含めてください。極端に短い回答は避けましょう。対面インタビューのように、明確で具体的な説明を心がけてください.",
            "GotPotential_NoQuestions_Description": "専門的なコンピテンシーや動機に関して、大幅な改善が必要な回答は見つかりませんでした。それらのトピックについてはよく回答できています.",
            "NotClearMatch_Questions_Description": "回答を改善できる質問が以下に表示されます。各質問の前の指示に従ってください。状況を説明する際は、状況、行動、結果を含めてください。極端に短い回答は避けましょう。対面インタビューのように、明確で具体的な説明を心がけてください.",
            "NotClearMatch_NoQuestions_Description": "「悪い」回答は見つかりませんでした。この職種に必要なものとの全体的な整合性が課題です。競争が激しい場合、小さなギャップが重要になることがあります.",
            "NotClearMatch_NoQuestions_DescriptionSecondary": "次のインタビューでは、具体性に焦点を当ててください。質問ごとに1つの例を選び、行動を説明し、結果を共有してください。短く具体的な回答は、長く一般的な回答よりも優れています.",
            "Alert_WantMoreAdvice": "Hubertインタビューで良い結果を出すためのアドバイスがもっと必要ですか？",
            "AlertLink_ExploreOurGeneralAdviceArticle": "一般的なアドバイス記事を見る"
        },
        "SimilarOffers": {
            "Title": "類似のオファー"
        },
        "HowHubertScoresInterviews": {
            "Title": "Hubertはどのようにインタビューを評価しますか？",
            "Description": "以下は、Hubertがインタビューの回答をどのように評価するかの簡単な説明です。Hubertインタビュー後の次のステップを説明する「採用プロセス」セクションも追加しました.",
            "Tabs_PossibleOutcomes": "可能な結果",
            "Tabs_RecruitmentProcess": "採用プロセス",
            "AssessedMatch_Title": "評価されたマッチ度",
            "AssessedMatch_Description": "Hubertは、採用担当者が通常この職種に求めているものと比較して、あなたの回答が全体的にどうであるかを評価します。職務要件とともに、以下の結果のいずれかが表示されます.",
            "AssessedMatch_DescriptionSecondary": "Hubertの評価は助言的なものです。最終決定は採用担当者が行い、候補者数などの他の要因も結果に影響を与える可能性があります.",
            "GreatMatch_Title": "高いマッチ度",
            "GreatMatch_Description": "あなたの回答は採用担当者が求めているものとよく一致しており、要件を満たしています。素晴らしいです。採用担当者は候補者を検討し、次のステップを決定します.",
            "GotPotential_Title": "高いポテンシャル、要件の確認が必要",
            "GotPotential_Description": "あなたの回答はこのタイプの職種に対して高いポテンシャルを示しています。ただし、この特定の仕事に必要な資格要件を1つ以上満たしていない可能性があります。これは次のステップに影響する可能性があります.",
            "OkMatch_Title": "要件を満たしています、さらにインパクトを",
            "OkMatch_Description": "あなたは要件を満たしています。際立つためには、回答に明確さと具体性が必要です。インタビューのフィードバックを活用して、将来のために例と結果を強化してください.",
            "NotClearMatch_Title": "現時点ではマッチしない可能性があります",
            "NotClearMatch_Description": "あなたの回答は採用担当者が求めているものと一致しない部分があるか、要件を満たしていない可能性があります。回答を見直し、明確さ、例、結果を追加できる場所を確認してください.",
            "ProfessionalExperiences_Title": "職務経験、動機、およびコンピテンシー",
            "ProfessionalExperiences_Description": "これらは、過去の経験、仕事への動機、およびその役割に関連するコンピテンシーに関する質問です。採用担当者が使用する質問を決定します.",
            "GreatResults_Title": "強力な回答",
            "GreatResults_Description": "あなたの回答は、この職種に適しており、明確に伝わったことを示しています。改善できる質問があれば、ハイライトされます.",
            "NotQualified_Title": "注力すべき点",
            "NotQualified_Description": "あなたの回答は、期待されるよりも具体性や成果の提示が少なかったかもしれません。具体的な例、行動、明確な結果を追加できる場所を探してください.",
            "QualifyingRequirements_Title": "基本または資格要件",
            "QualifyingRequirements_Description": "これらは、採用担当者がこの仕事のために設定した資格要件です。例えば、必要な証明書、運転免許証、または特定のレベルの経験などです.",
            "MeetingRequirements_Title": "要件を満たしています",
            "MeetingRequirements_Description": "あなたの回答は、設定された資格要件を満たしていることを示しています。良い基盤です.",
            "NotAllExpectationsMet_Title": "1つ以上の要件が不足",
            "NotAllExpectationsMet_Description": "回答に基づくと、この特定の仕事の資格要件を1つ以上満たしていない可能性があります.",
            "RecruitmentProcess_Title": "採用プロセス",
            "RecruitmentProcess_Description": "Hubertは通常、多くの候補者がいる採用プロセスの最初のステップとして使用されます。これにより、全員がインタビューを受け、自分の言葉で自分自身について話すことができます。質問は全員同じであるため、プロセスは一貫しています。Hubertは年齢、性別、外見などの情報を使用しないため、無意識のバイアスのリスクを軽減します.",
            "EventOne_Title": "Hubertによるインタビュー",
            "EventOne_Description": "都合の良い時間と場所でインタビューを受けられます。時間制限はなく、いつでも休憩して再開できます.",
            "EventTwo_Title": "インタビューの評価",
            "EventTwo_Description": "Hubertは最新技術を使用して回答を評価します。評価が完了するとすぐに、結果はMy Hubertと採用担当者に表示されます.",
            "EventThree_Title": "採用担当者による選考",
            "EventThree_Description": "採用担当者は新しい結果を確認し、回答と評価を検討します。助言的な評価と自身の判断に基づき、次のステップ（電話、テスト、最終面接）に進むかどうかを決定します。他の候補者がより適している場合、応募が見送られることもあります.",
            "ButtonText_Close": "閉じる"
        }
    },
    "MyProfile": {
        "Title": "マイプロフィール",
        "MyDetails": {
            "Title": "詳細情報",
            "Label_FirstName": "名",
            "Label_LastName": "姓",
            "Label_Email": "メールアドレス",
            "Label_PhoneNumber": "電話番号",
            "ButtonText_UpdateDetails": "詳細を更新",
            "Error_FirstName_Required": "名は必須です。",
            "Error_LastName_Required": "姓は必須です。",
            "Error_Email_Required": "メールアドレスは必須です。",
            "Error_Email_Invalid": "有効なメールアドレスを入力してください。",
            "Error_PhoneNumber_Invalid": "電話番号が無効です。",
            "Success_Details_Updated": "プロフィールが更新されました。"
        },
        "ChangePassword": {
            "Title": "パスワードの変更",
            "Set_Password_Title": "パスワードの作成",
            "Label_CurrentPassword": "現在のパスワード",
            "Label_NewPassword": "新しいパスワード",
            "Label_RepeatNewPassword": "新しいパスワード（確認）",
            "Alert_SignInAgain": "パスワードを設定するには再度ログインしてください。",
            "ButtonText_UpdatePassword": "パスワードを更新",
            "ButtonText_SetPassword": "パスワードを設定",
            "ButtonText_SignInAgain": "再ログイン",
            "Error_CurrentPassword_Required": "現在のパスワードは必須です。",
            "Error_CurrentPassword_DoesntMatch": "パスワードが一致しません。",
            "Error_NewPassword_Required": "新しいパスワードは必須です。",
            "Error_NewPassword_6_Characters": "新しいパスワードは6文字以上である必要があります。",
            "Error_RepeatNewPassword_Required": "パスワード（確認）は必須です。",
            "Error_RepeatNewPassword_DoesntMatch": "パスワードが一致しません。",
            "Success_Password_Changed": "パスワードが更新されました。",
            "Error_Invalid_CurrentPassword": "現在のパスワードが無効です。"
        },
        "NotificationPreferences": {
            "Title": "通知設定",
            "Label_ReceiveUpdatesToggle": "Hubertの更新情報を受け取る。",
            "Label_ReceiveUpdatesToggleHelpText": "キャリアガイドやインタビューのヒントなどを受け取れます。"
        },
        "AccountRemoval": {
            "Title": "アカウント削除",
            "ButtonText_RemoveMyAccount": "アカウントを削除"
        }
    },
    "PreInterviewPage": {
        "Title_Hello": "こんにちは",
        "Subtitle": "インタビューを始めようとしています。",
        "TipBox_Title": "役立つヒントをいくつかご紹介します。",
        "TipBox_Tip1": "集中して快適に入力できる静かな場所でインタビューを行ってください。",
        "TipBox_Tip2": "キーボード付きのコンピュータで回答することをお勧めします（モバイルでの入力に慣れている場合を除く）。",
        "TipBox_Tip3": "回答はできるだけ具体的かつ詳細に。Hubertと採用担当者はあなたのことをよく知りたいと思っています。",
        "TipBox_Tip4": "必要なだけ時間をかけてください。時間制限はありません。",
        "TipBox_Tip5": "いつでも休憩して、中断したところから再開できます。",
        "TipBox_Tip6": "自分らしく、対面インタビューと同じ意気込みで臨んでください。",
        "CheckAdviceArticle_Text1": "インタビューで成功するためのヒントがもっと必要な場合は、この",
        "CheckAdviceArticle_Text2": "記事",
        "CheckAdviceArticle_Text3": "をご覧ください。",
        "ReadyToGetStarted": "準備はいいですか？",
        "ORSeparator_Text": "または",
        "ButtonText_StartInterviewNow": "インタビューを開始",
        "ButtonText_SetReminder": "準備ができていないので、リマインダーを設定",
        "PrivacyPolicyText": "インタビューを開始することで、以下に同意したことになります",
        "PrivacyPolicyLink": "プライバシーポリシーおよび利用規約"
    },
    "InterviewCompletedPageInviteEmail": {
        "CompletedAlert_Title": "お疲れ様でした！",
        "CompletedAlert_Subtitle": "インタビューが完了しました。",
        "CompletedAlert_Description": "採用担当者がすべての応募を確認し、更新があり次第、メールまたは電話でフィードバックを提供します.",
        "InterviewNotCompleted": "このインタビューは完了していません。"
    },
    "HelpCenter": {
        "BannerSection": {
            "Title": "ヘルプセンター",
            "Subtitle": "Hubertに関するよくある質問への回答をご覧ください。",
            "Label_Search": "よくある質問を検索",
            "ButtonText_Search": "検索"
        },
        "FAQSection": {
            "Tabs_All": "すべて",
            "Tabs_AboutHubertInterview": "Hubertインタビューについて",
            "Tabs_TechnicalSupport": "テクニカルサポート"
        },
        "StillHaveQuestion": {
            "Title": "まだ質問がありますか？",
            "Description": "喜んでお手伝いします.",
            "DropUsAEmail": "hubert@hubert.ai までメールしてください"
        },
        "Q&ATexts": {
            "AboutHubertInterview": [
                {
                    "q": "電話でインタビューを受けることはできますか？",
                    "a": "Hubertは現在チャットのみで動作します。医学的な理由でインタビューを受けられない場合は、採用企業に直接ご連絡ください。"
                },
                {
                    "q": "別の言語でインタビューを受けることはできますか？",
                    "a": "一部のインタビューでは開始時に言語を選択できます。このオプションがない場合、言語の理解が要件である可能性が高いです。詳しくは採用企業にお問い合わせください。"
                },
                {
                    "q": "短い回答だと不利になりますか？",
                    "a": "いいえ、適切に回答していれば問題ありません。ただし、詳細な回答が役立つことが多いです。"
                },
                {
                    "q": "回答を再利用できますか？",
                    "a": "はい、My Hubertにログインして類似の職種に応募する場合、可能です。"
                },
                {
                    "q": "人間がインタビューを読みますか？",
                    "a": "はい、お客様には手動で確認するようお願いしています。"
                },
                {
                    "q": "インタビューが終わりました、次はどうなりますか？",
                    "a": "結果は採用担当者に送信されます。回答と評価を確認し、次のステップ（電話、テスト、面接）に進むかを決定します。"
                },
                {
                    "q": "次のステップについて質問があります、誰に連絡すればいいですか？",
                    "a": "応募した企業にご連絡ください。"
                },
                {
                    "q": "バイアスを防ぐためにどうしていますか？",
                    "a": "Hubertは一貫性があり、年齢、性別、外見などの情報を知らないため、無意識のバイアスを軽減します。"
                },
                {
                    "q": "人間の面接官に変更できますか？",
                    "a": "応募した企業にお問い合わせください。"
                },
                {
                    "q": "Hubertは人間ですか？",
                    "a": "いいえ、コンピュータシステムです。"
                },
                {
                    "q": "後で回答を変更できますか？",
                    "a": "いいえ、実際の面接と同様、やり直しはできません。"
                },
                {
                    "q": "どうすれば成功しますか？",
                    "a": "質問をよく読み、指示に従い、実例を挙げ、正直に答えてください。"
                },
                {
                    "q": "仕事が必要です、誰に連絡すればいいですか？",
                    "a": "応募した企業にご連絡ください。"
                },
                {
                    "q": "連絡がありません。どうすればいいですか？",
                    "a": "採用担当者が決定します。他の候補者が適している場合、連絡がないこともあります。採用担当者に確認してみてください。"
                },
                {
                    "q": "経験があるのに次のステップに進めませんでした。なぜですか？",
                    "a": "競争が激しい場合があります。企業にフィードバックを求めるか、My Hubertでアドバイスを確認してください。"
                },
                {
                    "q": "インタビューの所要時間は？",
                    "a": "10〜25分程度です。急ぐ必要はありません。"
                },
                {
                    "q": "データ処理についてはどこで読めますか？",
                    "a": "https://www.hubert.ai/candidate-privacy-policy"
                }
            ],
            "TechnicalSupport": [
                {
                    "q": "過去のインタビューが見られないのはなぜですか？",
                    "a": "応募時と同じメールアドレス（Googleログイン含む）を使用しているか確認してください。"
                },
                {
                    "q": "メールが届かないのはなぜですか？",
                    "a": "迷惑メールフォルダを確認してください。または、My Hubertアカウントを作成してリンクを見つけてください。"
                },
                {
                    "q": "メール内のリンクが見つかりません。",
                    "a": "迷惑メールフォルダを確認するか、My Hubertにログインして「マイインタビュー」を確認してください。"
                },
                {
                    "q": "モバイルで動作しますか？",
                    "a": "はい。ただし、PCの方が入力しやすい場合があります。"
                },
                {
                    "q": "動かない場合どうすればいいですか？",
                    "a": "hubert@hubert.ai までご連絡ください。"
                },
                {
                    "q": "アカウントを削除したいのですが。",
                    "a": "hubert@hubert.ai までご連絡ください。"
                },
                {
                    "q": "中断した場合、どうすれば戻れますか？",
                    "a": "メールのリンクをクリックするか、My Hubertにログインしてください。"
                }
            ]
        }
    },
    "LearnWithHubert": {
        "BannerSection": {
            "Title": "Hubertで学ぶ",
            "Subtitle": "採用プロセスでのチャンスを広げ、仕事でより良いパフォーマンスを発揮する方法を見つけましょう。",
            "Label_Search": "ガイドを検索",
            "ButtonText_Search": "検索"
        },
        "TabSelector": {
            "MyFeed": "マイフィード",
            "InterviewGuides": "インタビューガイド",
            "CareerGuides": "キャリアガイド"
        },
        "NewestOnTheFeed": "最新",
        "PickedForMe": "最新記事",
        "InterviewGuides": "インタビューガイド",
        "CareerGuides": "キャリアガイド"
    },
    "Article": {
        "ButtonText_BackToAllArticles": "すべての記事に戻る"
    },
    "ForgotPassword": {
        "ResetLinkAlert_Title": "パスワードのリセット",
        "ResetLinkAlert_Subtitle": "メールで送信されたリンクをクリックして新しいパスワードを設定してください。",
        "PasswordNotSetAlert_Message": "パスワードが設定されていません。次でログインしてください: ",
        "ResetYourPassword": {
            "MainTitle": "Hubertインタビューの結果を確認する",
            "Subtitle": "ログインして結果を確認し、フィードバックなどを得ましょう。",
            "FormSectionTitle": "パスワードをリセット",
            "Label_NewPassword": "新しいパスワード",
            "Label_ConfirmNewPassword": "新しいパスワード（確認）",
            "Error_NewPassword_Required": "新しいパスワードを入力してください。",
            "Error_Password_6_Characters": "新しいパスワードは6文字以上である必要があります。",
            "Error_ConfirmNewPassword_Required": "新しいパスワードを確認してください。",
            "Error_ConfirmNewPassword_NotMatch": "パスワードが一致しません。",
            "Error_MalformedResetUrl": "無効なセキュリティコードです。再試行してください。",
            "Error_ResetPasswordFailed": "リセット中に問題が発生しました。再試行してください。",
            "Error_WeakPassword": "パスワードは6文字以上である必要があります。",
            "Error_InvalidCode_Title": "リクエストが無効か期限切れです。",
            "Error_InvalidCode_Subtitle": "もう一度パスワードリセットを試してください。",
            "ButtonText_SetNewPassword": "設定してログイン",
            "ButtonText_RememberYourPassword": "パスワードを思い出しましたか？",
            "ButtonText_SignInInstead": "代わりにログイン"
        }
    },
    "PageNotFound": {
        "Title": "ページが見つかりません",
        "Description": "お探しのページが見つかりません.",
        "ButtonText_GoToDashboard": "ダッシュボードへ",
        "ButtonText_GoToLogin": "ログインへ"
    },
    "OldInterviewRedirectionModal": {
        "DescriptionLine1": "このインタビューでは回答の再利用はまだ利用できません。近日中に利用可能になる予定ですが、今すぐインタビューを受けることは可能です.",
        "DescriptionLine2": "以下のボタンをクリックしてインタビューに進んでください.",
        "ButtonText_TakeMeToTheInterview": "インタビューへ"
    },
    "UnsubscribeFromEmails": {
        "Title": "よろしいですか？",
        "Subtitle": "この仕事に関するメールを受け取らなくなります：",
        "SelectTheReason": "理由を選択してください。",
        "ReasonText1": "他の仕事が見つかった。",
        "ReasonText2": "この仕事に興味がなくなった。",
        "ReasonText3": "その他",
        "ButtonText_Unsubscribe": "配信停止",
        "Placeholder_YourReason": "理由",
        "Success_Title": "配信停止しました。",
        "Loading": "読み込み中...",
        "Error_YourReason_Required": "理由を入力してください。",
        "Error_ServerIssue": "サーバーエラーにより失敗しました。"
    },
    "SocialLoginCallback": {
        "ButtonText_TryAgain": "もう一度お試しください"
    },
    "Outreach": {
        "CandidateNotFound": "候補者が見つかりません",
        "CandidateNotFoundDesc": "お探しの面接の詳細が見つかりませんでした。",
        "InterviewEnded": "面接終了",
        "InterviewEndedDesc1": "この面接セッションは終了したか、利用できなくなっています。",
        "InterviewEndedDesc2": "お時間をいただきありがとうございました。ご不明な点がございましたら、採用チームまでお問い合わせください。",
        "ReadyTitle": "{{firstName}}さん、面接の準備はよろしいですか？",
        "InvitationDesc": "Hubertは{{companyName}}に代わって、約1〜2分で完了するチャット形式の面接にご案内します。",
        "Button_StartChat": "チャット面接を開始する",
        "CancelNotice": "ここから開始すると、この職種に関して予定されていた電話はキャンセルされます。",
        "PreferNotToContinue": "辞退されますか？",
        "DeclineLabel": "この職種には興味がありません。この件に関して今後、電話やメッセージを送らないでください。",
        "Button_ConfirmAndDecline": "確定して辞退する",
        "Processing": "処理中...",
        "Toast_DeclineSuccess": "面接を辞退しました",
        "Toast_CancelVoiceInfo": "音声面接がキャンセルされました。この機能は近日公開予定です。",
        "Toast_CancelError": "面接のキャンセルに失敗しました。もう一度お試しください。",
        "Footer_WithdrawConsent": "同意はいつでも撤回できます。詳細は、",
        "Footer_PrivacyPolicySuffix": "のプライバシーポリシー",
        "Footer_And": "および",
        "Footer_HubertPrivacyLink": "Hubertのプライバシーポリシーと利用規約",
        "Chat_InterviewWith": "{{companyName}}の面接",
        "Chat_StatusConnected": "接続済み",
        "Chat_StatusError": "エラー",
        "Chat_StatusDisconnected": "切断",
        "Chat_StatusConnecting": "接続中...",
        "Chat_ReadyToStart": "面接を開始しますか？",
        "Chat_ButtonStart": "面接を開始する",
        "Chat_SayHello": "挨拶をして会話を開始してください。",
        "Chat_EmptyState": "メッセージを送信して面接を開始してください。",
        "Chat_SelectLanguage": "言語を選択してください",
        "Chat_Placeholder": "メッセージを入力してください...",
        "Chat_ButtonSend": "送信",
        "Chat_ButtonBack": "戻る",
        "LoadingCandidateDetails": "候補者の詳細を読み込んでいます...",
        "FetchingCandidateDetails": "候補者の詳細を取得しています...",
        "Chat_StatusReady": "接続待機中...",
        "Chat_ForbiddenError": "このチャット面接は現在ご利用いただけません。",
        "Chat_GeneralError": "チャットの開始に失敗しました。後でもう一度お試しください。",
        "Chat_SelectUiLanguage": "メニュー言語",
        "Chat_InterviewTitle": "採用面接"
    }
}
